<template>
  <div id="app" class="sample-order-app-container">
    <progressbar :progressbar="getProgressbar"></progressbar>
  </div>
</template>
<script>
  import {translate} from "./service/translation";
  import progressbar from "@/components/progressbar/progressbar";

  export default {
    name : 'ColorSampleOrdering4',
    components : {
      progressbar
    },
    props: {
      currency: {
        required: true,
        type: String
      },
    },
    data : function() {
      return {
        currentStep : 4,
        progressbar:{
          'step0': 'active',
          'step1': '',
          'step2': '',
          'step3': ''
        }
      }
    },
    methods : {
      trans(key){
        return translate(key);
      },
    },
    computed : {
      getProgressbar: function (){
        if(this.currentStep ==1){
          return {
            'step0': 'active',
            'step1': '',
            'step2': '',
            'step3': ''
          }
        }else if(this.currentStep ==2){
          return {
            'step0': 'passed',
            'step1': 'active',
            'step2': '',
            'step3': ''
          }
        }else if(this.currentStep ==3){
          return {
            'step0': 'passed',
            'step1': 'passed',
            'step2': 'active',
            'step3': ''
          }
        }else{
          return {
            'step0': 'passed',
            'step1': 'passed',
            'step2': 'passed',
            'step3': 'active'
          }
        }
      }
    }
  }
</script>
<style lang="less">
.color-sample-checkout-title {
  font-family: "FranklinGothicDemiITC";
  font-style: normal;
  font-weight: normal;
  font-size: 32px;
  color: #000000;
}
.color-order-checkout-container {
  padding: 15px 0px;
}
#color-order-checkout {
  width: 100%;
  display: block;
  background: #E4E4E4;
  color: white;
  text-align: center;
  padding: 10px;
  text-decoration: none;
  text-transform: uppercase;
  font-family: "FranklinGothicBookITC";
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
}
#color-order-checkout-v2.type-2 {
  &:not(.color-sample-checkout-active) {
    background: #E4E4E4 !important;
  }
}
.color-sample-checkout-active {
  &:not(.type-2) {
    cursor: pointer;
    background: #DF0A25 !important;
  }
}
h3 {
  font-family: "FranklinGothicBookITC";
  font-size: 62px;
  font-style: normal;
  font-weight: 400;
  line-height: 70px;
  letter-spacing: 0em;
  text-align: left;
}
#color-sample-cost {
  .cell {
    font-family: "FranklinGothicBookITC";
    font-size: 19px;
    font-style: normal;
    font-weight: 400;
    line-height: 34px;
    letter-spacing: 0em;
    text-align: left;
    &:last-child {
      text-align: right;
    }
  }
  .color-sample-cost-row {
    display: flex;
    justify-content: space-between;
    padding-top: 10px;
    width: 100%;
    &:first-child {
      border-bottom: 2px solid #E3E3E3;
    }
    &:nth-child(2) {
      border-bottom: 2px solid #E3E3E3;
    }
  }
}
.color-sample-payment-methods {
  background: rgba(196, 196, 196, 0.25);
  padding: 10px 20px 10px 20px;
  margin-bottom: 10px;
}
.color-sample-payment-icon {
  float: left;
  margin-right: 10px;
}
@media only screen and (min-width: 940px) {
  .color-sample-sidebar {
    padding-left: 20px !important;
  }
  .color-sample-items {
    padding-top: 20px !important;
  }
}

</style>